import React from "react";
import { useForm } from "react-hook-form";
import { COLOR_CONFIG_URL } from "../../../../api/api_routing_urls";
import useAuth from "../../../../authentication/hooks/useAuth";
// import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import axios from "../../../../api/axios";
import AddButton_v2 from "../../../../reusable-components/buttons/AddButton_v2";
import Button from "../../../../reusable-components/buttons/Button";
import SubmitButton from "../../../../reusable-components/buttons/SubmitButton";
import Input from "../../../../reusable-components/inputs/InputTextBox/Input";
import { button, cancel_button } from "../../../../theme/lightTheme";
import showToast from "../../../../utilities/notification/NotificationModal";

const AddColorForm = ({
  getColorList,
  editColorDetails,
  setEditColorDetails,
  setShowAddForm,
}) => {
  // const axiosPrivate = useAxiosPrivate();
  // const { auth } = useAuth();

  const isEdit = Object.keys(editColorDetails)?.length > 0;

  const defaultValues = {
    color_name: !isEdit ? "" : editColorDetails?.color_name,
    color_code: !isEdit ? "" : editColorDetails?.color_code,
  };
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    clearErrors,
    reset,
    setValue,
  } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
    criteriaMode: "all",
    shouldFocusError: true,
    shouldUnregister: true,
  });

  const onSubmit = async (data) => {
    try {
      let response = "";
      if (!isEdit) {
        // data.createdby = auth.userid;
        data.createdby = "admin";
        response = await axios.post(COLOR_CONFIG_URL, data);
      } else {
        // data.updatedby = auth.userid;
        data.updatedby = "admin";
        data.color_id = editColorDetails?.color_id;
        response = await axios.post(`${COLOR_CONFIG_URL}/update`, data);
      }

      // console.log({ response });

      if (response.status === 200) {
        if (isEdit) {
          setEditColorDetails({});
          showToast("Color details has been updated successfully.", "success");
        } else {
          showToast("Color details has been added successfully.", "success");
        }
        getColorList();
      } else {
        if (isEdit) {
          console.log("Save Color Details Error:", response.data);
        } else {
          if (response.data.saveColorDetails.includes("unique_color")) {
            showToast(
              "Color already exists. Cannot insert duplicate color.",
              "error"
            );
          } else {
            showToast(
              "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
              "error"
            );
          }
        }
        return;
      }
      setShowAddForm(false);
      reset();
    } catch (error) {
      if (!error?.response) {
        showToast("No Server Response", "error");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided.", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
          "error"
        );
      }
    }
  };

  return (
    <section>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          defaultName="color_name"
          register={register}
          name="Color Name"
          required={true}
          pattern={null}
          errors={errors}
          placeholder="Enter color name"
          setError={setError}
          clearError={clearErrors}
          autoComplete="off"
          type="text"
          classes={`rounded-lg px-3 py-2 text-sm w-full focus:outline-none focus:ring-0 focus:border-2 focus:border-black`}
          onChangeInput={null}
          defaultValue={defaultValues.color_name}
          setValue={setValue}
        />
        <Input
          defaultName="color_code"
          register={register}
          name="Color Code"
          required={true}
          pattern={null}
          errors={errors}
          placeholder="Enter color code"
          setError={setError}
          clearError={clearErrors}
          autoComplete="off"
          type="text"
          classes={`rounded-lg px-3 py-2 text-sm w-full focus:outline-none focus:ring-0 focus:border-2 focus:border-black`}
          onChangeInput={null}
          defaultValue={defaultValues.color_code}
          setValue={setValue}
        />
        <div className="flex justify-between">
          <SubmitButton
            isSubmitting={isSubmitting}
            label={!isEdit ? "Submit" : "Update"}
            className={button}
          />
          <Button
            onClick={() => {
              setEditColorDetails({});
              setValue("color_name", "");
              setValue("color_code", "");
              setShowAddForm(false);
            }}
            aria-label="Cancel Color Update Button"
            className={cancel_button}
          >
            Cancel
          </Button>
        </div>
      </form>
    </section>
  );
};

export default AddColorForm;
